<template>
    <FormElement class="JsonSchemaFormBoolean" :label="form.schema.title" :required="required" force-error-slot>
        <template #requiredIndicator>
            {{ translate('requiredLabel') }}
        </template>

        <FormInput :invalid="accessed && hasError" force-action-slot>
            <div :id="id" class="JsonSchemaFormBoolean__radios">
                <RadioOption
                    :name="id"
                    value="yes"
                    :checked="value === true"
                    :disabled="disabled"
                    @click="onChange(true)"
                >
                    <span>{{ translate('boolean.yes') }}</span>
                </RadioOption>

                <RadioOption
                    :name="id"
                    value="no"
                    :checked="value === false"
                    :disabled="disabled"
                    @click="onChange(false)"
                >
                    <span>{{ translate('boolean.no') }}</span>
                </RadioOption>
            </div>
            <template v-if="deletable" #actionButtons>
                <NewButton
                    variant="flat"
                    size="icon-sm"
                    color="secondary"
                    class="JsonSchemaForm__deleteIcon"
                    @click="$emit('delete')"
                >
                    <FontAwesomeIcon :icon="faXmark" />
                </NewButton>
            </template>
        </FormInput>

        <template v-if="accessed && error" #errorMessage>
            {{ error }}
        </template>
    </FormElement>
</template>

<script lang="ts">
    import { Component } from 'vue-property-decorator';

    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaBoolean } from '@evidentid/json-schema/interfaces/JsonSchema';

    import { FormElement, FormInput } from '../../Form';
    import NewButton from '../../new-button/NewButton.vue';
    import { RadioOption } from '../../RadioOption';

    import AbstractJsonSchemaForm from './AbstractJsonSchemaForm';

    type JsonFormBoolean = JsonFormBase<JsonSchemaBoolean>;

    @Component({
        emits: [ 'delete', 'input' ],
        components: { FormInput, FormElement, RadioOption, FontAwesomeIcon, NewButton },
        inheritAttrs: false,
    })
    export default class JsonSchemaBooleanForm extends AbstractJsonSchemaForm<JsonFormBoolean, boolean> {
        private faXmark = faXmark;

        private onChange(value: boolean) {
            this.touch();
            this.$emit('input', this.form.getValue(value));
        }
    }
</script>
